import { Badge, Chip as F7Chip } from 'framework7-react';
import { CSSProperties, ReactElement, ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import './Chip.scss';

export const Chip = ({
  className = '',
  startIcon,
  startIconStyle,
  label,
  disabled = false,
  roundness = 'default',
  color = 'default',
  variant = 'default',
  size = 'md',
  badge,
  notificationBadge,
  onClick,
  onRemove,
  style,
}: {
  className?: string;
  startIcon?: ReactNode;
  startIconStyle?: CSSProperties;
  label: string | ReactElement;
  disabled?: boolean;
  color?: 'default' | 'neutral' | 'green' | 'orange' | 'purple' | 'deeppurple' | 'red' | 'yellow';
  variant?: 'default' | 'outlined';
  roundness?: 'default' | 'rounded';
  size?: 'sm' | 'md' | 'lg';
  badge?: number;
  notificationBadge?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  style?: CSSProperties;
}) => {
  const ref = useRef<{ el: HTMLDivElement }>(null);
  const classNamesAppended = `chip chip-color-${color} chip-variant-${variant} chip-size-${size} chip-roundness-${roundness} ${disabled ? 'disabled' : ''} ${className}`;

  const [isMounted, setIsMounted] = useState(false);

  useLayoutEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  return (
    <F7Chip
      ref={ref}
      className={classNamesAppended}
      text={typeof label === 'string' ? label : ''}
      outline={variant === 'outlined'}
      onClick={onClick}
      deleteable={!!onRemove}
      onDelete={onRemove}
      color={color}
      style={style}
    >
      {startIcon && (
        <div slot="media" style={startIconStyle}>
          {startIcon}
        </div>
      )}
      {typeof label !== 'string' ? label : undefined}
      {badge && <Badge>{badge}</Badge>}
      {notificationBadge &&
        isMounted &&
        createPortal(<Badge className="notification-badge" color="red" />, ref.current?.el)}
    </F7Chip>
  );
};
